import { NotificationType } from '@vista/omnichannel-components-domain';
import { getNotificationDetailsForPasswordApiError } from '../../../../subcomponents/form/field/password/utils/get-notification-details-for-api-error';
import { getIdForComponentNotification } from '../../../../utils/get-id-for-component-notification';
const componentName = 'member-password-reset-form';
export const getNotificationDetailsForError = (displayText, error) => {
    const notificationDetails = getNotificationDetailsForPasswordApiError(componentName, displayText, error);
    if (notificationDetails)
        return notificationDetails;
    return {
        id: getIdForComponentNotification(componentName, NotificationType.Error, 'failed-to-reset'),
        messages: [displayText.apiFailedErrorMessage]
    };
};
